import { useState } from 'react';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { useTranslation } from 'react-i18next';
import { CustomFieldResponse } from '@layouts/pages/Settings/general/custom-fields/services/responses/custom-field.response';
import { displayCustomFieldValue } from '@layouts/pages/Settings/general/custom-fields/custom-field-value';
import { LeadResponse } from '../../kanban-board/services/responses/lead.response';
import { LeadBlock, LeadField } from './lead-block';
import { LeadCustomFieldsModal } from './lead-custom-fields-modal';

interface Props {
    lead: LeadResponse;
    /// Ativos e arquivados; o bloco mostra só os ativos.
    fields: CustomFieldResponse[];
    onChanged: () => void;
}

/// Os campos criados para o lead; sem campo ativo o bloco some (vazio parece dado não carregado).
export const LeadCustomFields = ({ lead, fields, onChanged }: Props) => {
    const { t } = useTranslation();
    const [editing, setEditing] = useState(false);

    const active = fields.filter((field) => field.active);

    if (active.length === 0) return null;

    const valueOf = (fieldId: string) =>
        lead.customFieldValues?.find((value) => value.customFieldId === fieldId)?.value;

    return (
        <>
            {/* Linha inteira: sozinho numa coluna, deixaria duas vazias ao lado. */}
            <LeadBlock
                columns={3}
                title={t('telaLead.camposPersonalizados')}
                action={{
                    label: t('general.editar'),
                    icon: <EditOutlinedIcon sx={{ fontSize: '15px !important' }} />,
                    onClick: () => setEditing(true),
                }}
            >
                {active.map((field) => (
                    <LeadField
                        key={field.id}
                        label={field.name}
                        value={displayCustomFieldValue(field, valueOf(field.id), t)}
                    />
                ))}
            </LeadBlock>

            <LeadCustomFieldsModal
                lead={lead}
                fields={active}
                open={editing}
                onClose={() => setEditing(false)}
                onSaved={onChanged}
            />
        </>
    );
};
